import { Paper, PaperProps } from "@mui/material";
import React from "react";

export const MainListContainer = (props: PaperProps) => (
    <Paper
        elevation={3}
        sx={{
            margin: "136px 24px 24px 24px",
            flexGrow: 2,
            maxWidth: "calc(100vw - 240px)",
            ...props.sx,
        }}
    >
        {props.children}
    </Paper>
);
